import { Component, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../../../shared/shared.module';
import { DatePickerComponent } from '../../../shared/components/date-picker/date-picker.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { FEtrTradeProvider } from '../../common/providers/f-etr-trade.provider';
import { OpenTradeBaseComponent } from '../open-trade-base.component';

@Component({
  standalone: true,
  selector: 'app-f-etr-trade',
  templateUrl: './f-etr-trade.component.html',
  styleUrls: ['./f-etr-trade.component.scss'],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    SharedModule,
    DatePickerComponent,
    FormsModule,
    TooltipModule,
  ],
  providers: [FEtrTradeProvider],
})
export class FEtrTradeComponent extends OpenTradeBaseComponent {
  readonly #fEtrTradeProvider = inject(FEtrTradeProvider);

  fEtrTradeForm: FormGroup;

  protected override onInitialize(): void {
    if (this.currentData?.acquisitionId) {
      this.componentService.pageTitle.set('Edit a Trade');
      this.isEdit = true;
    }
    this.#fEtrTradeProvider.initForm({ ...this.currentData, type: this.type });
    this.fEtrTradeForm = this.#fEtrTradeProvider.fEtrTradeForm;
  }

  protected override getMainForm(): FormGroup {
    return this.fEtrTradeForm;
  }

  get form2TradeDocumentsControl() {
    return this.getTradeDocumentsControl(this.fEtrTradeForm);
  }

  override fileChange(element: Event, acronym: string): void {
    super.fileChange(element, acronym, this.fEtrTradeForm);
  }

  selectCreditor(event: any): void {
    if (event) {
      this.showTradeDocumentForEdit(
        event,
        this.fEtrTradeForm,
        event?.requiredTradeDocTypes,
      );
    }
  }

  onSubmit(): void {
    if (this.fEtrTradeForm.invalid) return;
    this.submitFormData(this.fEtrTradeForm.getRawValue());
  }
}
